import { EET_REQUIRED_MEANS_OF_PAYMENT } from '~/config/constants';

const isForcedEetAtPayment = payment => Boolean(
  EET_REQUIRED_MEANS_OF_PAYMENT.filter(val => val === payment).length,
);
export default isForcedEetAtPayment;
